import { Buffer } from 'buffer';

(globalThis as any).global = globalThis;
(globalThis as any).Buffer = Buffer;
(globalThis as any).process = {
    env: { DEBUG: undefined },
    version: '',
    nextTick: (fn: (...args: any[]) => void, ...args: any[]) => queueMicrotask(() => fn(...args))
} as any;
